import * as shelfLifeUpdateReasonsService from '../../../services/ShelfLife/shelfLifeUpdateReasonsService';
import {gridsNames} from "../../../enums/gridsNames";
import * as gridActionsHelper from "infrastructure/js/components/Grid/Utils/gridActionsHelper";

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_MAT_SETTINGS_SHELF_LIFE_UPDATE, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    return shelfLifeUpdateReasonsService.fetchShelfLifeUpdateReasons(query);
  }
};

function _convertToRowData(rows) {
  let items = rows.map((obj) => {
    return obj;
  });
  return items;
};

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
